<template>
  <span>
    <v-dialog v-model="dialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>{{activatorIcon ? activatorIcon:'mdi-pencil'}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>Edit Account
          <v-spacer/>
          <v-btn @click="dialog=false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <account-form ref="accountform" :hideLogo="false" :account.sync="account" />
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="updateLogo">Update Logo</v-btn>
          <v-btn class="ml-0 ml-lg-5" color="primary" @click="updateAccount">Update</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    activatorIcon: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      name: "",
      code: "",
      email: "",
      dialog: false
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading"])
  },
  components: {
    AccountForm: () => import("@/components/AccountForm.vue")
  },
  mounted() {
    this.name = this.account.name;
    this.email = this.account.email;
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    updateLogo() {

      let formData = new FormData();
      if(this.account.logo){
        formData.append('logo', this.account.logo)
      }

      const params = {
        accountId: this.account.id
      }
      
      this.$axios
        .post("/account/update-logo", formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          params
        })
        .then(() => {
          console.log("updated account");
          this.addSuccessMessage("Logo updated");
          this.dialog = false;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
    updateAccount() {
      if (!this.$refs.accountform.$refs.form.validate()) {
        this.addErrorMessage("Please check all required fields are entered");
        return;
      }

      const data = Object.assign({}, this.account);
      data.logo = null;
      data.admins = null;
      data.locations = null;
      data.accountTerminologies = null;
      data.admins = null;
      data.profileMappingSet = null;

      this.$axios
        .post("/account/info", data)
        .then(() => {
          console.log("updated account");
          this.addSuccessMessage("Account updated");
          this.dialog = false;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  }
};
</script>

<style>
</style>